import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import GenerateEstimateForm from './GenerateEstimateForm'
import { downloadEstimate, getAccountDetailsByGst } from '@data'
import { convertDataFile } from '@utils'
import { showToast } from '@data/state/action'

const initialFormState = {
	remarks: {
		name: 'remarks',
		label: strings('remarks'),
		disabled: false,
		value: `1. PRICES ARE BASIC AND F.O.R AT SITE
2. WEIGHT VARIATION : -/+ 0.5% ON THIRD PARTY WEIGHING SCALES
3. UNLOADING ON SITE UNDER CLIENT'S SCOPE AND NO REFUND/RETURN SHALL BE ENTERTAINED
4. QUANTITIES MAY VARY DEPENDING ON THE UNIT WEIGHT OF THE SECTIONS`,
		dirty: false,
	},
	account_detail: {
		name: 'account_detail',
		label: strings(['select', 'mbook', 'bank']),
		disabled: false,
		value: '',
		dirty: false,
	},
	billing_address: {
		name: strings('billing', 'address'),
		label: strings(['select', 'billing', 'address']),
		disabled: false,
		value: '',
		dirty: false,
	},
}

const deriveFormStateQuotesItemData = (oldState = initialFormState, data, editable = true) => {
	const derivedState = { ...oldState }

	derivedState.billing_address.value = data?.billing_address ?? ''
	derivedState.billing_address.disabled = !editable

	return derivedState
}

const Index = ({ enquiry, editable = true }) => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(initialFormState)
	const [accountDetails, setAccountDetails] = useState([])
	const mbookGst = enquiry?.mbook_billing_address ?? null
	const billingAddress = enquiry?.billing_address ?? null

	useEffect(() => {
		setFormState((_oldState) => deriveFormStateQuotesItemData(_oldState, enquiry, !!editable))
	}, [editable])

	// The banks offered are the ones attached to the Mbook GST on this enquiry, so the lookup is by
	// GST rather than by organisation.
	useEffect(() => {
		const gst = mbookGst?.gst
		if (!gst) {
			setAccountDetails([])
			return
		}
		getAccountDetailsByGst(gst)
			.then((res) => setAccountDetails(Array.isArray(res?.account_details) ? res.account_details : []))
			.catch((err) => {
				console.log(err)
				setAccountDetails([])
			})
	}, [mbookGst?.gst])

	const onChangeHandler = (key) => (value) => {
		setFormState({ ...formState, [key]: { ...formState[key], value } })
	}

	const onClickGenerateEstimateHandler = () => {
		const gst_detail = mbookGst
		const account_detail = formState.account_detail.value || null
		const billing_address = formState.billing_address?.value === '' ? null : formState.billing_address?.value
		if (!gst_detail) {
			dispatch(showToast(true, strings('msg_fill_mbook_billing_address'), { type: TOAST_TYPE.ERROR }))
			return
		}

		const remarks = formState.remarks.value
		downloadEstimate(enquiry?.enquiry_id, { gst_detail, account_detail, billing_address, remarks })
			.then((res) => {
				convertDataFile(res?.data, 'mb_estimate_' + new Date().getTime(), 'application/pdf')
			})
			.catch((err) => console.log(err))
	}

	const clearHandler = () => {
		setFormState(initialFormState)
	}

	const disableButton = !formState?.account_detail?.value
	return (
		<>
			<DrawerBodyWrapper>
				<GenerateEstimateForm
					formState={formState}
					accountDetails={accountDetails}
					mbookGst={mbookGst}
					billingAddress={billingAddress}
					// addresses={addresses}
					onChangeHandler={onChangeHandler}
				/>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button margin={`0 0 0 auto`} small uppercase type='primary' onClick={onClickGenerateEstimateHandler} disabled={disableButton}>
					{strings('generate', 'proforma')}
				</Button>
				<Button small uppercase type='secondary' variant='destructive' onClick={clearHandler} disabled={disableButton}>
					{strings('clear')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default Index
